import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Spinner extends Vue {
  public get showOverlay() {
    return this.$store.state.axiosRequestsStore.pendingRequests.count > 0;
  }
}
